/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AllPhasesDropdown_phases = ReadonlyArray<{
    readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly projectId: string | null;
    } | null;
    readonly " $refType": "AllPhasesDropdown_phases";
}>;
export type AllPhasesDropdown_phases$data = AllPhasesDropdown_phases;
export type AllPhasesDropdown_phases$key = ReadonlyArray<{
    readonly " $data"?: AllPhasesDropdown_phases$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AllPhasesDropdown_phases">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AllPhasesDropdown_phases",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhaseTypeEdge"
};
(node as any).hash = '3395666153959a186fca1718aeed5341';
export default node;
